import { useTranslation } from "react-i18next"
import { useQueryState } from "@/hooks"
import { SelectFilter } from "./SelectFilter"

const filterName = "role"

export function RoleFilter() {
  const { t } = useTranslation()
  const items = [
    { value: "admin", label: t("Admin") },
    { value: "manager", label: t("Manager") },
    { value: "user", label: t("Employee") },
  ]
  const [value, setValue] = useQueryState<string>(filterName)

  return (
    <SelectFilter
      items={items}
      value={value as string}
      label={t("Filter by role")}
      setValue={(value) => setValue(value && value?.length > 0 ? value : undefined)}
    />
  )
}

RoleFilter.filterName = filterName

RoleFilter.useValue = () => {
  const [value] = useQueryState<string>(filterName)
  return value
}
